var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useFormik } from "formik";
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import PlayIcon from '@mui/icons-material/PlayCircleOutline';
import { CardControlMui } from "../../../shared/card/card-control-mui";
import { HppBillingInformationControl } from "../hpp-billing-info-control";
import { PaymentInputValidation } from "../../../shared/card/validator/cardValidationScheme";
import { enqueueSnackbar } from "notistack";
import { getErrorMessage } from "../../../utilities/axios-utility";
import { errorSnackbar } from "../../../shared/snackbar-constants";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import { useTranslation } from "react-i18next";
import * as yup from "yup";
import { FormConstants } from "../../../shared/components/forms/Constants";
export var CardControlPage = function (_a) {
    var sessionData = _a.sessionData, processorCommonCode = _a.processorCommonCode, setPaymentResult = _a.setPaymentResult, setPaymentResultOpened = _a.setPaymentResultOpened, setPaymentInProgress = _a.setPaymentInProgress, paysafeSettings = _a.paysafeSettings, api = _a.api;
    var _b = useState(false), opened = _b[0], setOpened = _b[1];
    var _c = useState(false), isChallenge = _c[0], setIsChallenge = _c[1];
    var _d = useState(""), paymentId = _d[0], setPaymentId = _d[1];
    var PaysafeUrl = 'https://hosted.paysafe.com/threedsecure/js/latest/paysafe.threedsecure.min.js';
    var t = useTranslation().t;
    var _e = useState(false), showStripeIframe = _e[0], setShowStripeIframe = _e[1];
    var _f = useState(''), stripeIframeSrc = _f[0], setStripeIframeSrc = _f[1];
    useEffect(function () {
        if (processorCommonCode == "PYSF3D") {
            var script_1 = document.createElement('script');
            script_1.src = PaysafeUrl;
            script_1.id = "paysafeScript";
            script_1.async = true;
            document.body.appendChild(script_1);
            return function () {
                document.body.removeChild(script_1);
            };
        }
    }, []);
    useEffect(function () {
        var pollingTimeout;
        var steps = 50;
        var currentStep = 0;
        var pollPaymentStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, api.GetPaymentStatus(paymentId)];
                    case 1:
                        response = _a.sent();
                        if (response.data.detail.state !== "CHALLENGE_REQUESTED") {
                            clearTimeout(pollingTimeout); // Stop polling
                            setPaymentResultOpened(true);
                            setPaymentResult(response.data);
                            setIsChallenge(false);
                            setOpened(false);
                        }
                        else {
                            if (currentStep < steps) {
                                currentStep++;
                                pollingTimeout = setTimeout(pollPaymentStatus, 2000);
                            }
                            else {
                                clearTimeout(pollingTimeout);
                                setPaymentResultOpened(true);
                                setPaymentResult(response.data);
                                setIsChallenge(false);
                                setOpened(false);
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error getting payment status:', error_1);
                        setPaymentResultOpened(true);
                        setIsChallenge(false);
                        setOpened(false);
                        clearTimeout(pollingTimeout); // Stop polling on error
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        if (opened && isChallenge) {
            pollingTimeout = setTimeout(pollPaymentStatus, 2000);
        }
        // Cleanup function to clear the timeout when the component unmounts
        return function () {
            clearTimeout(pollingTimeout);
        };
    }, [opened, isChallenge]);
    var handleClosePaymentDetails = function (event, reason) {
        if (reason && reason === "backdropClick") {
            return;
        }
        setOpened(false);
    };
    var emptyConfig = {
        cardNumber: "",
        city: "",
        country: "",
        cvc: "",
        dateOfBirth: null,
        email: "",
        expiryDate: "",
        name: "",
        phoneNumber: "",
        state: "",
        street: "",
        surname: "",
        zip: ""
    };
    var FormikSubmit = function (request) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPaymentInProgress(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setPaymentResultOpened(true);
                    return [4 /*yield*/, api.OpenPayment(request)];
                case 2:
                    response = _a.sent();
                    setPaymentId(response.data.detail.internalOrderId);
                    ThreeDSCheck(response.data);
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    setPaymentInProgress(false);
                    enqueueSnackbar(getErrorMessage(error_2), errorSnackbar);
                    return [3 /*break*/, 4];
                case 4:
                    setPaymentInProgress(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var translatedBillingValidationScheme = yup.object({
        name: yup.string().required(t(FormConstants.FieldIsRequired)),
        surname: yup.string().required(t(FormConstants.FieldIsRequired)),
        country: yup.string().required(t(FormConstants.FieldIsRequired)).nullable(),
        city: yup.string().required(t(FormConstants.FieldIsRequired)),
        state: yup.string().when('country', {
            is: function (val) { return val === "CA" || val === 'US'; },
            then: yup.string().required(t(FormConstants.FieldIsRequired))
        }).nullable(),
        street: yup.string().required(t(FormConstants.FieldIsRequired)),
        zip: yup.string().required(t(FormConstants.FieldIsRequired)),
        email: yup.string().email(t("email must be a valid email")).required(t(FormConstants.FieldIsRequired)),
        phoneNumber: yup.string().required(t(FormConstants.FieldIsRequired)).min(3, "Min 3 chars"),
    });
    var formik = useFormik({
        initialValues: emptyConfig,
        validationSchema: sessionData.clientLock ? null : translatedBillingValidationScheme,
        validate: function (values) { return PaymentInputValidation(values, sessionData.options); },
        enableReinitialize: true,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var expiryMonth, expiryYear, request;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        expiryMonth = (_a = values.expiryDate) === null || _a === void 0 ? void 0 : _a.split("/")[0];
                        expiryYear = (_b = values.expiryDate) === null || _b === void 0 ? void 0 : _b.split("/")[1];
                        request = {
                            processorCommonCode: processorCommonCode,
                            paymentSessionId: sessionData.paymentSessionId,
                            cardNumber: (_c = values.cardNumber) === null || _c === void 0 ? void 0 : _c.replaceAll(' ', ''),
                            city: values.city,
                            country: values.country,
                            cvv: values.cvc,
                            dateOfBirth: values.dateOfBirth,
                            email: values.email,
                            expiryMonth: expiryMonth,
                            expiryYear: expiryYear,
                            name: values.name,
                            phoneNumber: values.phoneNumber,
                            state: values.state,
                            street: values.street,
                            surname: values.surname,
                            zip: values.zip,
                            deviceFingerprintId: values.deviceFingerprintId,
                            authenticationId: values.authenticationId,
                            bypassLuhnValidation: (_d = sessionData.options) === null || _d === void 0 ? void 0 : _d.bypassLuhnValidation,
                        };
                        return [4 /*yield*/, FormikSubmit(request)];
                    case 1:
                        _e.sent();
                        return [2 /*return*/];
                }
            });
        }); }
    });
    var onSubmit = function () {
        if (processorCommonCode == "PYSF3D" && document.getElementById('paysafeScript') && paysafeSettings && formik.values["cardNumber"]) {
            var cardNumber = formik.values["cardNumber"].replaceAll(' ', '');
            // @ts-ignore
            paysafe.threedsecure.start(paysafeSettings.paysafePublicToken, {
                environment: paysafeSettings.environment,
                accountId: paysafeSettings.paysafeAccountId,
                card: {
                    cardBin: cardNumber.substring(0, 6)
                }
            }, function (deviceFingerprintingId) {
                formik.values["deviceFingerprintId"] = deviceFingerprintingId;
                formik.handleSubmit();
            });
        }
        else {
            formik.handleSubmit();
        }
    };
    var onSubmit3Ds = function () {
        // setOpened(false)
        // formik.handleSubmit();
    };
    var ThreeDSCheck = function (response) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (response.code == 200001) {
            setPaymentResultOpened(false);
            setPaymentInProgress(false);
            var fObjFinger = response.redirect;
            var iframeFinger = document.getElementById('iframeFingerPrint');
            if (iframeFinger) {
                var htmlFinger = '<body onload="document.forms[\'frm\'].submit()"><form name="frm" method="POST" action="' +
                    fObjFinger.url +
                    '">';
                for (var paramFinger in fObjFinger.data) {
                    if (Object.prototype.hasOwnProperty.call(fObjFinger.data, paramFinger)) {
                        htmlFinger += '<input type="hidden" name="' +
                            fObjFinger.data[paramFinger].key +
                            '" value="' +
                            fObjFinger.data[paramFinger].value +
                            '">';
                    }
                }
                htmlFinger += '</form></body>';
                (_a = iframeFinger.contentWindow) === null || _a === void 0 ? void 0 : _a.document.open();
                (_b = iframeFinger.contentWindow) === null || _b === void 0 ? void 0 : _b.document.write(htmlFinger);
                (_c = iframeFinger.contentWindow) === null || _c === void 0 ? void 0 : _c.document.close();
            }
            formik.handleSubmit();
        }
        else if (response.code == 200002 && processorCommonCode == 'PYSF3D' && paysafeSettings && document.getElementById('paysafeScript')) {
            setPaymentResultOpened(false);
            setPaymentInProgress(false);
            var paysafeChallenge = response.redirect.data;
            var paysafeObjChallenge = paysafeChallenge[0].value;
            // @ts-ignore
            paysafe.threedsecure.challenge(paysafeSettings.paysafePublicToken, {
                environment: paysafeSettings.environment,
                sdkChallengePayload: paysafeObjChallenge
            }, function (authenticationId) {
                formik.values["authenticationId"] = authenticationId;
                formik.handleSubmit();
            });
        }
        else if (response.code == 200002 && (processorCommonCode == 'STRIPE' || ((_d = response.redirect) === null || _d === void 0 ? void 0 : _d.method) === 'GET')) {
            setShowStripeIframe(true);
            setStripeIframeSrc(response.redirect.url);
            setOpened(true);
            setIsChallenge(true);
            setPaymentResultOpened(false);
            setPaymentInProgress(false);
        }
        else if (response.code == 200002) {
            setIsChallenge(true);
            setPaymentResultOpened(false);
            setPaymentInProgress(false);
            var fObjChallenge = response.redirect;
            var iframeChallenge = document.getElementById('iframeChallenge');
            var divPopUp = document.getElementById('popupRedirect');
            iframeChallenge.setAttribute("style", "");
            if (iframeChallenge && divPopUp) {
                var htmlChallenge = '<body onload="document.forms[\'frm\'].submit()"><form name="frm" method="POST" action="' +
                    fObjChallenge.url +
                    '">';
                for (var paramChallenge in fObjChallenge.data) {
                    if (Object.prototype.hasOwnProperty.call(fObjChallenge.data, paramChallenge)) {
                        htmlChallenge += '<input type="hidden" name="' +
                            fObjChallenge.data[paramChallenge].key +
                            '" value="' +
                            fObjChallenge.data[paramChallenge].value +
                            '">';
                    }
                }
                htmlChallenge += '</form></body>';
                (_e = iframeChallenge.contentWindow) === null || _e === void 0 ? void 0 : _e.document.open();
                (_f = iframeChallenge.contentWindow) === null || _f === void 0 ? void 0 : _f.document.write(htmlChallenge);
                (_g = iframeChallenge.contentWindow) === null || _g === void 0 ? void 0 : _g.document.close();
                setOpened(true); // open IFramePopUp
            }
        }
        else {
            setPaymentResult(response);
        }
    };
    return (_jsxs(_Fragment, { children: [sessionData.clientLock ?
                _jsx(_Fragment, {})
                :
                    _jsxs(_Fragment, { children: [_jsx(HppBillingInformationControl, { formik: formik, geoData: sessionData.geoOptionData }), _jsx("br", {})] }), _jsx(CardControlMui, { formik: formik }), _jsx("br", {}), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 6, sx: { minWidth: 300, padding: 2 } }, { children: _jsx(Button, { fullWidth: true, variant: "contained", color: 'success', startIcon: _jsx(PlayIcon, {}), onClick: onSubmit, children: t('Pay') }) })), _jsx(Grid, __assign({ item: true, xs: 6, sx: { display: "none" } }, { children: _jsx(Button, { hidden: true, id: "cardPayBtn", variant: "contained", color: 'success', startIcon: _jsx(PlayIcon, {}), onClick: onSubmit3Ds, children: t('Pay') }) }))] })), _jsx(Dialog, __assign({ keepMounted: true, id: "popupRedirect", open: opened, onClose: handleClosePaymentDetails, fullWidth: true }, { children: _jsx(DialogContent, { children: _jsxs(Paper, __assign({ elevation: 3, sx: { width: "100%", height: "100%" } }, { children: [_jsx("iframe", { id: "iframeChallenge", style: { visibility: "hidden", display: "none" }, height: 1000, width: 600 }), _jsx("iframe", { id: "iframeFingerPrint", style: { visibility: "hidden", display: "none" } }), showStripeIframe ?
                                _jsx("iframe", { id: "iframeChallengeStripe", allow: 'payment', src: stripeIframeSrc, height: 400, width: 390 })
                                :
                                    _jsx(_Fragment, {})] })) }) }))] }));
};
